import { IServerResponse } from "app/interface";

export interface DocumentSignatureState {
  documentSignatureList: Array<any>;
  documentSignatureByFieldList: Array<any>;
  documentSignatureById: any;
  saveDocumentSignatureResp: IServerResponse;
  updateDocumentSignatureResp: IServerResponse;
  deleteDocumentSignatureResp: IServerResponse;
  resendDocumentSignatureResp: any;
  refreshSignatureStatus: any;
}

export const initialState: DocumentSignatureState = {
  documentSignatureList: null,
  documentSignatureByFieldList: null,
  documentSignatureById: {},
  saveDocumentSignatureResp: null,
  updateDocumentSignatureResp: null,
  deleteDocumentSignatureResp: null,
  resendDocumentSignatureResp: null,
  refreshSignatureStatus: null,
};
